module.exports = __webpack_public_path__ + "static/media/testimonial (5).fc543ff8.png";